import { Alert, Box, IconButton, Typography } from '@mui/joy';

import CrossIcon from '@/assets/icons/cross.svg?react';
import WarningIcon from '@/assets/icons/warning-circle.svg?react';
import { getApiError, getErrorStatusText } from '@/utils/ErrorHelper';

type ErrorAlertProps = { error: Error | null; onClose?: () => void };

export function ErrorAlert({ error, onClose }: ErrorAlertProps) {
  if (!error) {
    return null;
  }

  return (
    <Alert
      variant="outlined"
      color="danger"
      sx={{ paddingX: 2, paddingY: 2, gap: 4, display: 'flex', alignItems: 'center', flexDirection: 'row' }}
    >
      {onClose && (
        <IconButton onClick={() => onClose()} sx={{ position: 'absolute', top: 0, right: 0 }}>
          <CrossIcon />
        </IconButton>
      )}
      <WarningIcon style={{ width: 24, height: 'auto', flexShrink: 0 }} />
      <Box>
        <Typography level="title-lg">{getErrorStatusText(error) || 'Fehler'}</Typography>
        <Typography>{getApiError(error).message || 'Unbekannter Fehler bei der Anfrage'}</Typography>
      </Box>
    </Alert>
  );
}
